import UserAvatar from "./UserAvatar";
import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Url from "../../util/url";
import { toast } from "react-toastify";
import split from "../../assets/images/Split-shop.png";

const InfoUser = ({ myProfile, showDetail }) => {
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.authState.user);
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({
        firstName: myProfile?.firstName ?? "",
        lastName: myProfile?.lastName ?? "",
        gender: myProfile?.gender ?? "",
        email: myProfile?.email ?? "",
        ssoEmail: myProfile?.ssoEmail ?? "",
        birth: myProfile?.birth ? moment(myProfile.birth).format("YYYY-MM-DD") : "",
        discordID: myProfile?.discordID ?? "",
        address: myProfile?.address ?? "",
    });

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const data = {
                ...form,
                birth: form.birth ? new Date(form.birth).getTime() : undefined,
            };
            await axios.patch(Url("user/info/" + myProfile._id), data);
            toast.success("Cập nhật thành công");
            setEditing(false);
            const updated = { ...currentUser, ...data };
            dispatch({ type: "LOGIN_SUCCESS", user: updated });
            dispatch({ type: "SET_USER_INFO", data: { ...myProfile, ...data } });
            localStorage.setItem("userInfo", JSON.stringify(updated));
        } catch (e) {
            toast.error("Cập nhật thất bại");
        } finally {
            setSaving(false);
        }
    };

    const handleAvatarUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("file", file);
        try {
            const res = await axios.post(Url("upload/avatar"), formData);
            const avatarUrl = res.data;
            await axios.patch(Url("user/info/" + myProfile._id), { avatar: avatarUrl });
            toast.success("Cập nhật avatar thành công");
            const updated = { ...currentUser, avatar: avatarUrl };
            dispatch({ type: "LOGIN_SUCCESS", user: updated });
            dispatch({ type: "SET_USER_INFO", data: { ...myProfile, avatar: avatarUrl } });
            localStorage.setItem("userInfo", JSON.stringify(updated));
        } catch {
            toast.error("Upload avatar thất bại");
        }
    };

    const userBirthday = myProfile?.birth ? moment(myProfile.birth).format("DD/MM/YYYY") : "Chưa cập nhật";

    const currentLevel = myProfile?.startDate
        ? Math.max(0, Math.floor((new Date() - new Date(myProfile.startDate)) / (30 * 24 * 60 * 60 * 1000)))
        : 0;

    const fieldStyle = {
        width: "100%",
        padding: "8px 12px",
        borderRadius: 8,
        border: "1px solid #d0d5dd",
        fontSize: 14,
        outline: "none",
        background: "#fff",
    };

    const labelStyle = {
        fontSize: 12,
        fontWeight: 600,
        color: "#344054",
        marginBottom: 4,
        display: "block",
    };

    const rowStyle = {
        marginBottom: 12,
    };

    return (
        <div>
            {myProfile && (
                <div className="user-template">
                    {/* Avatar + Name */}
                    <div className="user-item">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                            <div className="user-item-avatar">
                                <UserAvatar avatar={myProfile.avatar} />
                            </div>
                            <label style={{
                                fontSize: 12,
                                color: "#1570ef",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                            }}>
                                <span>📷</span> Đổi avatar
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleAvatarUpload}
                                />
                            </label>
                        </div>
                        <div className="user-item-info">
                            <div className="username">
                                {myProfile.firstName + " " + myProfile.lastName}
                            </div>
                            <div className="position">{myProfile.position}</div>
                            {/* <div style={{ fontSize: 12, color: "#98a2b3" }}>Level {currentLevel}</div> */}
                        </div>
                    </div>

                    <img className="split" src={split} />

                    {/* Profile info / Edit form */}
                    {!showDetail && !editing && (
                        <div className="userInfo">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                <span style={{ fontWeight: 600, fontSize: 15 }}>Thông tin cá nhân</span>
                                <button
                                    onClick={() => {
                                        setForm({
                                            firstName: myProfile?.firstName ?? "",
                                            lastName: myProfile?.lastName ?? "",
                                            gender: myProfile?.gender ?? "",
                                            email: myProfile?.email ?? "",
                                            birth: myProfile?.birth ? moment(myProfile.birth).format("YYYY-MM-DD") : "",
                                            discordID: myProfile?.discordID ?? "",
                                            address: myProfile?.address ?? "",
                                        });
                                        setEditing(true);
                                    }}
                                    style={{
                                        background: "#1570ef",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 6,
                                        padding: "6px 16px",
                                        fontSize: 13,
                                        cursor: "pointer",
                                    }}
                                >
                                    Chỉnh sửa
                                </button>
                            </div>
                            <table style={{ width: "100%", fontSize: 14 }}>
                                <tbody>
                                    {[
                                        ["Họ", myProfile.firstName],
                                        ["Tên", myProfile.lastName],
                                        ["Email", myProfile.email + (myProfile.emailActive === false ? " (chưa active)" : "")],
                                        ["Email SSO", myProfile.ssoEmail || "Chưa cập nhật"],
                                        ["Giới tính", myProfile.gender || "Chưa cập nhật"],
                                        ["Sinh nhật", userBirthday],
                                        ["Discord ID", myProfile.discordID || "Chưa cập nhật"],
                                        ["Team", myProfile.teams?.toUpperCase() || "Chưa cập nhật"],
                                        ["Chức vụ", myProfile.role === 0 ? "Nhân viên" : "Quản lý"],
                                        ["Ngày bắt đầu", myProfile.startDate ? moment(myProfile.startDate).format("DD/MM/YYYY") : "Chưa cập nhật"],
                                        ["Địa chỉ", myProfile.address || "Chưa cập nhật"],
                                    ].map(([label, value]) => (
                                        <tr key={label} style={{ borderBottom: "1px solid #f2f4f7" }}>
                                            <td style={{ padding: "8px 0", color: "#667085", width: 120 }}>{label}</td>
                                            <td style={{ padding: "8px 0", fontWeight: 500 }}>{value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Edit form */}
                    {!showDetail && editing && (
                        <div className="userInfo" style={{ padding: 16 }}>
                            <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 16 }}>Chỉnh sửa thông tin</div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                                <div style={rowStyle}>
                                    <label style={labelStyle}>Họ</label>
                                    <input style={fieldStyle} value={form.firstName} onChange={(e) => handleChange("firstName", e.target.value)} />
                                </div>
                                <div style={rowStyle}>
                                    <label style={labelStyle}>Tên</label>
                                    <input style={fieldStyle} value={form.lastName} onChange={(e) => handleChange("lastName", e.target.value)} />
                                </div>
                            </div>

                            <div style={rowStyle}>
                                <label style={labelStyle}>Email</label>
                                <input style={fieldStyle} value={form.email} onChange={(e) => handleChange("email", e.target.value)} />
                            </div>

                            <div style={rowStyle}>
                                <label style={labelStyle}>Email SSO (khớp tài khoản cv)</label>
                                <input style={fieldStyle} value={form.ssoEmail} onChange={(e) => handleChange("ssoEmail", e.target.value)} placeholder="VD: nguyenvana@gmail.com — để trống nếu trùng Email" />
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                                <div style={rowStyle}>
                                    <label style={labelStyle}>Giới tính</label>
                                    <select style={fieldStyle} value={form.gender} onChange={(e) => handleChange("gender", e.target.value)}>
                                        <option value="">Chọn</option>
                                        <option value="Nam">Nam</option>
                                        <option value="Nữ">Nữ</option>
                                    </select>
                                </div>
                                <div style={rowStyle}>
                                    <label style={labelStyle}>Sinh nhật</label>
                                    <input type="date" style={fieldStyle} value={form.birth} onChange={(e) => handleChange("birth", e.target.value)} />
                                </div>
                            </div>

                            <div style={rowStyle}>
                                <label style={labelStyle}>Discord ID</label>
                                <input style={fieldStyle} value={form.discordID} onChange={(e) => handleChange("discordID", e.target.value)} placeholder="VD: 869048935417798668" />
                            </div>

                            <div style={rowStyle}>
                                <label style={labelStyle}>Địa chỉ</label>
                                <input style={fieldStyle} value={form.address} onChange={(e) => handleChange("address", e.target.value)} />
                            </div>

                            <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
                                <button
                                    onClick={handleSave}
                                    disabled={saving}
                                    style={{
                                        background: "#1570ef",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 8,
                                        padding: "10px 24px",
                                        fontSize: 14,
                                        fontWeight: 500,
                                        cursor: saving ? "not-allowed" : "pointer",
                                        opacity: saving ? 0.6 : 1,
                                    }}
                                >
                                    {saving ? "Đang lưu..." : "Lưu thay đổi"}
                                </button>
                                <button
                                    onClick={() => setEditing(false)}
                                    style={{
                                        background: "#fff",
                                        color: "#344054",
                                        border: "1px solid #d0d5dd",
                                        borderRadius: 8,
                                        padding: "10px 24px",
                                        fontSize: 14,
                                        cursor: "pointer",
                                    }}
                                >
                                    Hủy
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InfoUser;
